import Controller from '../utils/Controller';
import { decorate, computed, action, observable, reaction } from 'mobx';

class Tappe extends Controller {
  constructor(options, manager) {
    super(options, manager);
    this.fetched = false;
    this.list = [];
    this.current= null
  }
 
  get map() {
    return this.list
      .reduce((agg, curr) => {
        agg[curr.id] = curr;
        return agg;
      }, {});
  }

  async init() {
    super.init();
    reaction(
      () => this.manager.controllers.eventi.current,
      () => {
        this.list = [];
        this.fetched = false;
        this.current = null;
      }
    )
  }

  get name() {
    return 'tappe'
  }

  get priority() {
    return 1001;
  }

  async get(id) {
    if (this.map[id]) {
      return this.map[id];
    } else {
      const currentEvent = this.manager.controllers.eventi.current;
      if (currentEvent) {
        const result = await this.manager.controllers.api.get(`/eventi/${currentEvent.id}/tappe/${id}`);
        this.list = [...this.list, result.Item];
        return result.Item;
      }
    }
  }

  async delete(id) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.del(`/eventi/${currentEvent.id}/tappe/${id}`) 
      this.list = this.list.filter(item => item.id !== result.Item.id);
    }
  }

  async fetch() {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.get(`/eventi/${currentEvent.id}/tappe`) 
      this.list = result.Items;
      this.fetched = true;
    }
  }

  async create(values) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.post(`/eventi/${currentEvent.id}/tappe`, {
        body: values
      });
      if (result) {
        this.list = [...this.list, result.Item]
      }
    }
  }

  async getGeocoding(id) { 
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const result = await this.manager.controllers.api.get(`/eventi/${currentEvent.id}/tappe/${id}/geocoding`);
      return result.Item;      
    }
  }


  find(id) {
    return this.list.findIndex(tappa => tappa.id === id);
  }

  replace(id, valore) {
    const temp = [...this.list];
    const idx = this.find(id);
    if (idx !== -1) {
      temp[idx] = valore;
      this.list = temp;
    }
  }

  async createSector(id, settore) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const tappa = {...await this.get(id)};
      delete tappa.id;
      
      if (!tappa.settori) tappa.settori = [];

      tappa.settori.push(settore);

      const result = await this.manager.controllers.api.put(`/eventi/${currentEvent.id}/tappe/${id}`, {
        body: tappa
      });
      console.dir(result);
      this.replace(id, result.Item);
    }
  }

  async deleteSector(id, indice) {
    const currentEvent = this.manager.controllers.eventi.current;
    if (currentEvent) {
      const tappa = {...await this.get(id)};
      delete tappa.id;
      if (!tappa.settori) tappa.settori = [];

      tappa.settori.splice(indice, 1);
      const result = await this.manager.controllers.api.put(`/eventi/${currentEvent.id}/tappe/${id}`, {
        body: tappa
      });
      console.dir(result);
      this.replace(id, result.Item);
    }
  }
  
}

export default decorate(Tappe, {
  list: observable,
  current: observable,
  map:computed,
  fetch: action,
  create: action,
  delete: action,
  createSector: action
});